export const RaceEnum = {
  American_Indian_or_Alaska_Native: 1,
  Asian: 2,
  Black_or_African_American: 3,
  // Hispanic_or_Latino: 4,
  Native_Hawaiian_or_Other_Pacific_Islander: 5,
  Other: 6,
  // Not_Hispanic_or_Latino: 7,
  No_Response: 8,
  White: 9,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/RaceEnum.js